import { render } from "./ProfileSettings.vue?vue&type=template&id=204a3092&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import "./ProfileSettings.vue?vue&type=style&index=0&id=204a3092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204a3092"]])

export default __exports__